import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { useDispatch, useStore } from 'react-redux';
import useRouteChangeEffect from './shared/hooks/useRouteChangeEffect';
import { ls } from './Helpers/LocalStorage';

const LIGHT_ROUTES = [
  '/alerts',
  '/reportsv2',
  '/driving-analysisv2',
  '/track-trace',
  '/dashboard',
  '/trip-management',
  '/liveTrack',
];

const clearSessionStorage = keys => {
  keys.forEach(key => sessionStorage.removeItem(key));
};

const AppContainer = ({
  children,
  enterDarkSide,
  enterLightSide,
}) => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const dispatch = useDispatch();
  const store = useStore();
  const previousLocation = useRef(location);

  useRouteChangeEffect((pathname) => {
    if (LIGHT_ROUTES.includes(pathname)) {
      enterLightSide();
    } else {
      enterDarkSide();
    }
  });

  useEffect(() => {
    if (previousLocation.current.key === location.key) {
      return;
    }

    const fromPath = previousLocation.current.pathname;
    previousLocation.current = location;

    if (
      navigationType !== 'PUSH' &&
      navigationType !== 'POP'
    ) {
      return;
    }

    if (fromPath === '/alerts') {
      clearSessionStorage([
        'alertFilterState',
        'lastSavedAlertData',
        'alertStateClicked',
        'alertReportFilterState',
        'lastSavedAlertReportData',
        'alertReportStateClicked',
      ]);
      ls.removeItem('selectedVehicleId');
    } else if (fromPath === '/track-trace') {
      clearSessionStorage([
        'filterState',
        'lastSavedFmtData',
        'filterStateClickedFMT',
        'rpFilterState',
        'lastSavedRpData',
        'filterStateClickedRp',
      ]);
    } else if (fromPath === '/driving-analysisv2') {
      clearSessionStorage([
        'driverScoreState',
        'lastSavedDriverScoreData',
        'driverScoreStateClicked',
        'driverScoreReportState',
        'lastSaveddriverScoreReportData',
        'driverScoreReportClicked',
      ]);
    } else if (fromPath === '/reportsv2') {
      clearSessionStorage([
        'reportFilterState',
        'lastSavedReportData',
        'reportStateClicked',
        'instantReportFilterState',
        'lastSavedInstantReportData',
        'instantReportStateClicked',
        'autotripReportFilterState',
        'lastSavedAutotripReportData',
        'autotripReportStateClicked',
        'trendsReportFilterState',
        'lastSavedTrendsReportData',
        'trendsReportStateClicked',
        'huhtohubReportFilterState',
        'lastSavedHubtohubReportData',
        'hubtohubReportStateClicked',
        'serviceDueReportFilterState',
        'lastSavedServiceDueReportData',
        'servicedueReportStateClicked',
      ]);
    } else if (fromPath === '/fleet-efficiency') {
      clearSessionStorage([
        'fleetEfficiencyFilterState',
        'lastSavedFleetEfficiencyData',
        'fleetEfficiencyStateClicked',
      ]);
      dispatch({
        type: 'FLTR_UI_STATE_FE',
        payload: {
          ...store.getState().fleetEfficiencyState.filter,
          selVehIds: [],
        },
      });
    } else if (
      fromPath === '/fleet-healthv2' ||
      fromPath.startsWith('/fleet-healthv2/')
    ) {
      clearSessionStorage([
        'fleetHealthFilterState',
        'lastSavedFleetHealthData',
        'fleetHealthStateClicked',
      ]);
      dispatch({
        type: 'FLTR_UI_STATE_FH',
        payload: {
          ...store.getState().fleetHealthState.filter,
          selVehIds: [],
        },
      });
    }
  }, [
    dispatch,
    location,
    navigationType,
    store,
  ]);

  return <div>{children}</div>;
};

export default AppContainer;